<template>      
  <div class="caption">        
    <v-layout>        
      <v-flex xs-11 class="pl-1">
        <v-slider hide-details class="my-0" @input="$store.myActions.UI_SET_LAYERMAP_OPACITY({layerId:layer.id,opacity:$event,uiid})" :value="mapState.layermapOpacity[layer.id] == 0?0:(mapState.layermapOpacity[layer.id]||100)" :min="0" :max="100" step=1 />    
      </v-flex>
      <v-flex  v-if="hasLayerOptions" xs-1 class="flex justify-center items-center settings ml-3" :class="{selected:showAdvancedConfig}">
        <v-icon @click.prevent="showAdvancedConfig = !showAdvancedConfig">mdi-cog</v-icon>
      </v-flex>          
    </v-layout>
    <admin-config-layer class="config pa-2" v-if="showAdvancedConfig" v-model="configLayer" />          
  </div>      
</template>
<script lang="ts">
  import { mapGetters } from 'vuex'
  import { groupBy } from '@/utils/groupBy'
  
  
  import AdminConfigLayer from '@/components/admin/mapLayer/AdminConfigLayer.vue'
  import { AloDbMapLayer } from '@/models/alodb/AloDbMapLayer'
  import Vue from 'vue'
  import Component from 'vue-class-component'
import { LayerConfig } from '@/models/ui/LayerConfig'
import { Watch } from 'vue-property-decorator'
import { LayerSourceType } from '@/enum/LayerSourceType'
import { MapUiState } from '@/models/ui/MapUiState'
    
@Component({
    name: 'MapPanelLayerConfig',
    components: {AdminConfigLayer},
     props:{
      uiid:{
          type: String,
          required: true
      },
      layer:{
        type: Object, 
        required: true
      }
    }
})
export default class MapPanelLayerConfig extends Vue {       
  showAdvancedConfig = false  
  layer!:AloDbMapLayer    
  uiid!:string


  get configLayer() {
    return this.mapState.layermapconfig[this.layer.id!] ?? new LayerConfig(this.rawConfigLayer)    
  }

  set configLayer(newValue) {    
    this.$store.myActions.UI_SET_LAYERMAP_CONFIG({layerId:this.layer.id!,config:newValue,uiid:this.uiid})
  }

  created() {    
  }
   
  get uistatebyuiid(){
    return this.$store.myGetters.uistatebyuiid
  }
  get mapState() {          
    return this.uistatebyuiid(this.uiid) as MapUiState
  }

  get rawConfigLayer(){
    return JSON.parse((this.layer.LAY_CONFIG_JSON?.length ?? 0 )>0?this.layer.LAY_CONFIG_JSON!:'{}')
  }

  get hasLayerOptions() {
    return this.configLayer.type != LayerSourceType.NONE  && 
     ((this.configLayer.colorscalemin != null  && this.configLayer.colorscalemax != null) || 
      Object.keys(this.configLayer.options ?? {}).some(k => this.configLayer.options[k]?.enable))
  }

}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>

.v-input__icon--append{
  justify-content: flex-end;  
}

.settings .v-icon{
  font-size:16px;  
}
.settings.selected{
  background: #eee;
  border-radius: 5px 5px 0px 0px;
}
.settings{
  max-width: 30px;  
}

.config{
  background:#eee;

  border-radius: 5px 0px 5px 5px;
}
</style>
